export default __webpack_public_path__ + "static/media/1541.bf2d31c2.png";